<template>
  <a-modal
    :visible="visible"
    title="Crear cola"
    :body-style="{ height: '630px', padding: '10px 24px' }"
    wrapClassName="add-queue-modal"
    width="830px"
    :keyboard="false"
    centered
    :mask-closable="false"
    @cancel="handleConfirmationClose"
  >
    <!-- <h3 class="modal-name">Crear cola</h3> -->
    <section class="steps">
      <CustomStepper
        style="padding-top: 0px"
        :value="current"
        @update:value="current = $event"
        :items="steps"
        readonly
      />
    </section>

    <section class="section">
      <CustomScrollbar ref="scrollToTop" height="calc(100% + 97px)">
        <KeepAlive>
          <component
            :key="view"
            :is="view"
            ref="step"
            @disable="handleDisable"
            v-bind="currentProperties"
            @onShowConfirmationModal="handleShowModal"
          />
        </KeepAlive>
      </CustomScrollbar>
    </section>

    <!-- <section class="section">
      <KeepAlive>
        <component
          :key="view"
          :is="view"
          ref="step"
          @disable="handleDisable"
          v-bind="currentProperties"
          @onShowConfirmationModal="handleShowModal"
        />
      </KeepAlive>
    </section> -->

    <template v-slot:footer>
      <a-divider class="divider" type="horizontal" />
      <div class="footer__container">
        <div class="footer__left">
          <div v-if="view == 'step-user-selection'">
            <a-button type="primary" ghost @click="handleUpdateUsers">Actualizar datos</a-button>

            <p class="footer__button">Actualizando datos en {{ countToUpdate }} segundos</p>
          </div>
        </div>
        <div class="footer__right">
          <a-button @click="handlePrevious"> {{ cancelText }} </a-button>
          <a-button
            type="primary"
            id="queue-modal-primary-btn"
            :loading="isLoading"
            :disabled="disabled"
            @click="handleOk"
          >
            {{ okText }}
          </a-button>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
import CustomStepper from "@/app/shared/components/organisms/CustomStepper.vue";
import StepInitialSettings from "@/app/queues/components/steps/StepInitialSettings.vue";
import StepUserSelection from "@/app/queues/components/steps/StepUserSelection.vue";
import StepCallSettings from "@/app/queues/components/steps/StepCallSettings.vue";
import StepNsTime from "@/app/queues/components/steps/StepNsTime.vue";
import StepQueuesTransfer from "@/app/queues/components/steps/StepQueuesTransfer.vue";
import StepChannelSelect from "@/app/queues/components/steps/StepChannelSelect.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { fetchCustomerChannels } from "@/app/shared/services";

import { QueuesEvent } from "@/app/queues/domain/events";
import EventBus from "@/app/shared/utils/eventBus";
import { defineComponent, createVNode, onMounted, provide, ref } from "vue";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";
import { Modal } from "ant-design-vue";

const steps = ["Conf. general", "Agregar canales", "Conf. llamadas", "Agrega usuarios"];
const views = [
  "step-initial-settings",
  "step-channel-select",
  "step-call-settings",
  "step-user-selection",
];
const initialStep = 0;
const TIME_TO_UPDATE = 5;
// const lastStep = steps.length - 1;

export default defineComponent({
  components: {
    CustomStepper,
    StepInitialSettings,
    StepUserSelection,
    StepCallSettings,
    StepNsTime,
    StepQueuesTransfer,
    StepChannelSelect,
    CustomScrollbar,
  },
  props: {
    value: {
      required: true,
      type: Boolean,
    },
  },
  setup() {
    let updateIntervalId = null;
    const countToUpdate = ref(TIME_TO_UPDATE);
    provide("countToUpdate", countToUpdate);
    const enableUsersPriority = ref(false);
    provide("enableUsersPriority", enableUsersPriority);
    
    onMounted(() => {
      updateIntervalId = setInterval(() => {
        countToUpdate.value = countToUpdate.value - 1;

        if (countToUpdate.value === 0) countToUpdate.value = TIME_TO_UPDATE;
      }, 1000);
    });

    return {
      countToUpdate,
      updateIntervalId,
    };
  },
  data() {
    return {
      current: initialStep,
      steps: steps,
      campaigns: [],
      // lastStep,
      initialStep,
      disabled: true,
      showConfirmModal: false,
      componentKey: 0,
      isLoading: false,
      channels: [],
    };
  },
  computed: {
    currentProperties() {
      return { isActive: true, isEdit: false };
    },
    view() {
      // const channelsCustomer = this.$store.getters["getQueueState"].channels_customer;
      // const channelsFilters = this.channels.filter((el) => channelsCustomer.includes(el.id));
      // const hasTelephone = channelsFilters.find((el) => el.channel_id == 7);

      // let views = [];
      // if (hasTelephone) {
      //   views = [
      //     "step-initial-settings",
      //     "step-channel-select",
      //     "step-call-settings",
      //     "step-user-selection",
      //   ];
      // } else {
      //   views = ["step-initial-settings", "step-channel-select", "step-user-selection"];
      // }
      return views[this.current];
    },
    // steps() {
    //   const channelsCustomer = this.$store.getters["getQueueState"].channels_customer;
    //   const channelsFilters = this.channels.filter((el) => channelsCustomer.includes(el.id));
    //   const hasTelephone = channelsFilters.find((el) => el.channel_id == 7);

    //   let steps = [];
    //   if (hasTelephone) {
    //     steps = ["Conf. general", "Agregar canales", "Conf. llamadas", "Agrega usuarios"];
    //   } else {
    //     steps = ["Conf. general", "Agregar canales", "Agrega usuarios"];
    //   }

    //   return steps;
    // },
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("closeModal", value);
      },
    },
    okText() {
      if (this.current === this.steps.length - 1) return "Crear";
      return "Continuar";
    },
    cancelText() {
      if (this.current === initialStep) return "Cancelar";
      return "Volver";
    },
    portfolio() {
      return this.$store.getters["getQueueState"].portfolios;
    },
  },
  async created() {
    await this.initialize();
    EventBus.$on(QueuesEvent.QUEUE_MODAL_ADD_OPENED, () => {
      this.showConfirmModal = false;
      this.initialize();
      if (this.$refs.step) this.$refs.step.handleReset();
    });
  },
  methods: {
    async initialize() {
      this.channels = await fetchCustomerChannels();
      this.current = initialStep;
      this.$store.dispatch("resetQueueState");
    },
    async handleOk() {
      try {
        this.isLoading = true;
        const current = await this.$refs.step.handleOk(this.current);
        if (current == null) this.handleClose();
        // if (current == this.lastStep + 1) {
        if (current == this.steps.length) {
          try {
            const { id } = (await this.$store.dispatch("createNewQueue")) || {};
            if (id) await this.$store.dispatch("uploadAudioFileQueue", { id, create: true });

            this.$emit("update");
            this.$message.success(`Se ha creado la cola correctamente `);
            this.handleClose();
          } catch (error) {
            // const errorMessage = error.data?.channels_customer?.[0] || "Ha ocurrido un error";
            const errorMessage = error?.getErrorMessage?.() || "Ha ocurrido un error";

            console.error(error);
            this.$message.error(errorMessage);
          }
        }
        this.$refs.scrollToTop?.scrollToTop();
        // this.current = current === this.lastStep + 1 ? this.current : current;
        this.current = current === this.steps.length ? this.current : current;
      } catch (e) {
        console.error(e);
        this.$message.warning("Algo salió mal, por favor, vuelve a intentarlo");
      } finally {
        this.isLoading = false;
      }
    },
    handlePrevious() {
      if (this.current === 0) {
        this.handleConfirmationClose();
      } else {
        this.current = this.current - 1;
      }
      this.$refs.scrollToTop?.scrollToTop();
    },
    handleDisable(value) {
      this.disabled = value;
    },
    handleCancel() {
      this.handleConfirmationClose();
    },
    handleClose() {
      this.visible = false;
      this.componentKey++;
      this.$store.dispatch("resetQueueState");
      if (this.$refs.step) this.$refs.step.handleReset();
      this.current = 0;
    },
    handleShowModal() {
      this.showConfirmModal = true;
    },
    handleConfirmationClose() {
      if (this.showConfirmModal) {
        Modal.confirm({
          title: "¿Deseas descartar los cambios realizados?",
          content: "Recuerda que si no guardas los cambios registrados, estos se perderán.",
          width: 450,
          icon: createVNode(QuestionCircleOutlined),
          onOk: () => this.handleClose(),
          centered: true,
          okText: "Sí, descartar cambios",
          cancelText: "No, seguir editando",
        });
      } else {
        this.handleClose();
      }
    },
    async handleUpdateUsers() {
      const id = this.portfolio[0];
      if (id) await this.$store.dispatch("fetchAgentsQueue", id);
      this.countToUpdate = TIME_TO_UPDATE;
    },
  },
  watch: {},
});
</script>

<style lang="sass" scoped>
.steps
  margin: 24px 0

.section
  height: 400px
  margin: 0 40px

.footer__container
  display: flex
  justify-content: space-between
  align-items: center

.footer__left
  gap: 10px
  div
    display: flex
    align-items: center
    p
      margin-bottom: 0
      margin-left: 1em

.footer__right
  display: flex
  align-items: center
  gap: 10px

.divider
  background-color: $gray-7
</style>
